import axios, { getServerErrorMessage } from '../utils/axios'
import * as c from '../constants/NotificationConstants'

export const getNotification =
  ({ orgId, educationPeriodCd, notificationType }) =>
  async dispatch => {
    let response
    dispatch({ type: c.FETCH_NOTIFICATION_PENDING, payload: { type: notificationType } })
    try {
      switch (notificationType) {
        case c.HOLD_NOTIFICATION:
          response = await axios.get(
            `${Config.API_URL}/paapro/v1/organizations/${orgId}/exam-order-hold`
          )
          break

        default:
          response = await axios.get(
            `${Config.API_URL}/notifications/organizations/${orgId}/education-periods/${educationPeriodCd}`,
            { params: { notificationType } }
          )
      }
      dispatch({
        type: c.FETCH_NOTIFICATION_FULFILLED,
        payload: { type: notificationType, data: response.data },
      })
    } catch (err) {
      let error
      if (Object.keys(err).length) error = getServerErrorMessage(err)
      else error = err
      dispatch({ type: c.FETCH_NOTIFICATION_REJECTED, payload: { type: notificationType, error } })
    }
  }

export const dismissNotification =
  ({ orgId, educationPeriodCd, notificationType, messageIds }) =>
  async dispatch => {
    dispatch({ type: c.DISMISS_NOTIFICATION_PENDING, payload: { type: notificationType } })
    try {
      const response = await axios.post(
        `${Config.API_URL}/notifications/organizations/${orgId}/education-periods/${educationPeriodCd}`,
        {
          messageIds,
        }
      )
      dispatch({
        type: c.DISMISS_NOTIFICATION_FULFILLED,
        payload: { type: notificationType, messageIds },
      })
    } catch (err) {
      dispatch({
        type: c.DISMISS_NOTIFICATION_REJECTED,
        payload: { type: notificationType, error: getServerErrorMessage(err) },
      })
    }
  }
